import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
const categories = ["All", "Web", "Mobile", "Design", "Cloud"];
const projects = [
    {
        id: 1,
        title: "E-Commerce Platform",
        description: "A full-stack e-commerce solution with real-time inventory management.",
        category: "Web",
        image: "/placeholder-project.jpg",
        tags: ["React", "Node.js", "PostgreSQL"],
        href: "/portfolio/e-commerce-platform",
    },
    {
        id: 2,
        title: "Healthcare Mobile App",
        description: "Patient management app with telemedicine capabilities.",
        category: "Mobile",
        image: "/placeholder-project.jpg",
        tags: ["React Native", "Firebase", "HIPAA"],
        href: "/portfolio/healthcare-app",
    },
    {
        id: 3,
        title: "SaaS Dashboard",
        description: "Analytics dashboard for B2B SaaS platform.",
        category: "Design",
        image: "/placeholder-project.jpg",
        tags: ["Figma", "Design System", "Prototyping"],
        href: "/portfolio/saas-dashboard",
    },
    {
        id: 4,
        title: "Cloud Migration",
        description: "Enterprise migration from on-premise to AWS.",
        category: "Cloud",
        image: "/placeholder-project.jpg",
        tags: ["AWS", "Docker", "Terraform"],
        href: "/portfolio/cloud-migration",
    },
    {
        id: 5,
        title: "Real Estate Platform",
        description: "Property listing and management platform with virtual tours.",
        category: "Web",
        image: "/placeholder-project.jpg",
        tags: ["Next.js", "Three.js", "Stripe"],
        href: "/portfolio/real-estate",
    },
    {
        id: 6,
        title: "Fitness Tracking App",
        description: "Cross-platform fitness app with social features.",
        category: "Mobile",
        image: "/placeholder-project.jpg",
        tags: ["Flutter", "Firebase", "Wearable"],
        href: "/portfolio/fitness-app",
    },
];
export function Portfolio({ showHeader = true }) {
    const [activeCategory, setActiveCategory] = useState("All");
    const filteredProjects = activeCategory === "All"
        ? projects
        : projects.filter((p) => p.category === activeCategory);
    return (_jsx("section", { className: "section-padding", children: _jsxs("div", { className: "container-page", children: [showHeader && (_jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [_jsx("h2", { className: "text-3xl font-bold tracking-tight sm:text-4xl", children: "Our Portfolio" }), _jsx("p", { className: "mt-4 text-lg text-muted-foreground", children: "Explore our latest work and see how we've helped businesses succeed." })] })), _jsx("div", { className: "mt-10 flex flex-wrap justify-center gap-2", children: categories.map((category) => (_jsx("button", { onClick: () => setActiveCategory(category), className: cn("rounded-lg px-4 py-2 text-sm font-medium transition-colors", activeCategory === category
                            ? "bg-primary text-primary-foreground"
                            : "bg-muted text-muted-foreground hover:bg-muted/80"), children: category }, category))) }), _jsx("div", { className: "mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3", children: filteredProjects.map((project) => (_jsxs(Link, { to: project.href, className: "group overflow-hidden rounded-xl border bg-card transition-all hover:shadow-lg", children: [_jsx("div", { className: "aspect-video bg-muted", children: _jsx("div", { className: "flex h-full items-center justify-center text-muted-foreground", children: "Project Image" }) }), _jsxs("div", { className: "p-6", children: [_jsxs("div", { className: "flex items-start justify-between", children: [_jsx("h3", { className: "text-lg font-semibold group-hover:text-primary transition-colors", children: project.title }), _jsx(ExternalLink, { className: "h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" })] }), _jsx("p", { className: "mt-2 text-sm text-muted-foreground line-clamp-2", children: project.description }), _jsx("div", { className: "mt-4 flex flex-wrap gap-2", children: project.tags.map((tag) => (_jsx(Badge, { variant: "secondary", className: "text-xs", children: tag }, tag))) })] })] }, project.id))) }), _jsx("div", { className: "mt-12 text-center", children: _jsx(Button, { variant: "outline", size: "lg", asChild: true, children: _jsxs(Link, { to: "/portfolio", children: ["View All Projects", _jsx(ArrowRight, { className: "ml-2 h-4 w-4" })] }) }) })] }) }));
}
